import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

export const useAmazonState = (key: string) => {
  const pathname = usePathname()
  const [state, setState] = useState('')
  const [buyerToken, setBuyerToken] = useState<string | null>(null)
  const [amazonCheckoutSessionId, setAmazonCheckoutSessionId] = useState<string | null>(null)
  const searchParams = useSearchParams()

  useEffect(() => {
    setBuyerToken(getState() == searchParams.get('state') ? searchParams.get('buyerToken') : null)
    setAmazonCheckoutSessionId(
      getState() == searchParams.get('state') ? searchParams.get('amazonCheckoutSessionId') : null
    )
  }, [pathname, state])

  const getState = () => {
    let loginWithAmazonSessionId = sessionStorage.getItem(key)
    if (loginWithAmazonSessionId == null) {
      loginWithAmazonSessionId = resetState()
    }

    return loginWithAmazonSessionId
  }

  const resetState = () => {
    const loginWithAmazonSessionId = uuidv4()
    sessionStorage.setItem(key, loginWithAmazonSessionId)
    setState(loginWithAmazonSessionId)
    return loginWithAmazonSessionId
  }

  return {
    getState,
    buyerToken,
    amazonCheckoutSessionId,
    resetState,
  }
}
